import { Button, Input } from "antd";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";

type GroupNameUpdateModalProps = ModalComponentProps & {
  isLoading: boolean;
  handleUpdateGroupName: () => void;
  groupName: string;
  setGroupName: (name: string) => void;
  groupNameError: boolean;
  setGroupNameError: (error: boolean) => void;
  originalGroupName: string;
};

export default function GroupNameUpdateModal({
  handleClose,
  handleUpdateGroupName,
  groupName,
  setGroupName,
  groupNameError,
  setGroupNameError,
  originalGroupName,
  isLoading,
  ...rest
}: GroupNameUpdateModalProps) {
  return (
    <CustomModal
      title="Rename Group"
      {...rest}
      handleClose={handleClose}
      width={360}
      footer={null}
    >
      <div>
        <div className="mt-1 mb-3">
          <Input
            placeholder="Enter New Group Name"
            value={groupName}
            onChange={(e) => {
              setGroupName(e.target.value);
              setGroupNameError(false);
            }}
            allowClear
            status={groupNameError ? "error" : ""}
          />
          {groupNameError && (
            <div className="text-red-500 text-sm mt-1">
              Group name is required.
            </div>
          )}
        </div>

        <div className="py-2 flex justify-between">
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            loading={isLoading}
            onClick={handleUpdateGroupName}
            disabled={
              !groupName.trim() || groupName.trim() === originalGroupName.trim()
            }
            className="bg-[#FFF1EB] text-[#FE7235] border-none"
          >
            Update
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
